module.exports = __webpack_public_path__ + "static/img/bg_feed.d376a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/bg_feed.png
// module id = IM6B
// module chunks = 1